import { Theme } from '@mui/material';

export const commonStyle = {
  flex: {
    display: 'flex',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  successColor: (theme: Theme) => ({
    color: theme.palette.success.light,
  }),
  redColor: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
  dialogFooter: {
    display: 'flex',
    padding: 6,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogDiscard: {
    borderRadius: 10,
    height: 40,
    width: 160,
    borderColor: 'rgba(29, 28, 29, 0.5)',
    color: '#000',
    '&:hover': {
      borderColor: 'rgba(29, 28, 29, 0.5)',
    },
  },
  dialogWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 4,
    width: 400,
    height: 230,
    backgroundColor: '#fff',
  },
  bulkDialogWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 4,
    width: 400,
    height: 260,
    backgroundColor: '#fff',
  },
  dialogHeader: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3, 4, 3, 8),
  }),
  dialogContent: (theme: Theme) => ({
    padding: theme.spacing(10, 8),
  }),
  bulkDialogContent: (theme: Theme) => ({
    padding: theme.spacing(0, 8),
    height: 100,
  }),
  dialogAction: {
    width: 175,
    borderRadius: 16,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto',
    width: '100%',
    paddingBottom: 5,
  },
};
